import Box from '@mui/material/Box';
import { SectionTitle, BodyText } from '../components/SectionPrimitives';

export function Section9(): JSX.Element {
  return (
    <Box sx={{ mb: '24px' }}>
      <SectionTitle>9. Governing Law</SectionTitle>
      <BodyText>
        The Agreement shall be governed by and construed in accordance with the
        laws of England and Wales. The parties irrevocably submit to the
        exclusive jurisdiction of the courts of England and Wales.
      </BodyText>
    </Box>
  );
}
